<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="contract-overview">
      <!-- @saleDeptChange="(value) => valueChangeHandler('saleDepartment', value)" -->
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @createDeptChange="(value) => valueChangeHandler('createDepartment', value)"
        @chargePersonChange="(value) => valueChangeHandler('chargePerson', value)"
        @serviceChange="(value) => valueChangeHandler('service', value)"
        @contractTypeChange="(value) => valueChangeHandler('contractType', value)"
        @contractStatusChange="(value) => valueChangeHandler('contractStatus', value)"
        @thirdPartyChange="(value) => valueChangeHandler('thirdParty', value)"
        @businessDepartmentChange="(value) => valueChangeHandler('businessDepartment', value)"
        @usableDepartmentChange="(value) => valueChangeHandler('usageDepartment', value)"
        @platformCompanyChange="(value) => valueChangeHandler('platformCompanyCode', value)"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          :loading="loading"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="() => getTableData()"
          @handleCurrentChange="() => getTableData()"
          @dblclickEvent="dblclickEvent"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="tableColumns"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field == 'contractStatus'">
                {{ getStatusName('contract', scope.row[item.field]) }}</span
              >
              <span
                v-else-if="
                  item.field == 'contractSignDate' ||
                  item.field == 'contractEffectDate' ||
                  item.field == 'contractExpireDate'
                "
              >
                {{ formatDateCustom(scope.row[item.field], false) }}</span
              >
              <span v-else-if="item.field == 'contractType'">
                {{ scope.row[item.field] == '0' ? '常规合同' : '结算条款' }}</span
              >
              <template v-else-if="item.field == 'oaUrl'">
                <a
                  href="javascript:void(0);"
                  v-if="scope.row[item.field]"
                  @click="goOaLink(scope.row[item.field])"
                  >查看</a
                >
              </template>
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <SetUsageDepartmentDialog
        ref="setUsageDepartmentRef"
        :departmentList="departmentList"
        :defaultDepartmentCode="defaultDepartmentCode"
        @confirm="changeUsageDepartment"
      />
      <SelectProjectDialog
        ref="projectSearchRef"
        title="项目转合同-选择项目"
        :extraData="getExtraData"
        confirmText="创建合同"
        @confirm="selectProjectHandler"
      ></SelectProjectDialog>
      <CommonTextDialog ref="textDialog"></CommonTextDialog>
      <SelectPartnerDialog
        ref="selectPartnerDialogRef"
        :isRadio="!isCustomerContract"
        @confirm="getPartnerType"
      ></SelectPartnerDialog>
    </div>
  </el-card>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { searchColumns, defaultTableColumns } from './columns';
  import ContractOverviewMixin from '@/pages/intermodality/contract/overview/ContractOverviewMixin';
  import ContractServiceMixin from '@/pages/intermodality/contract/detail/mixins/ContractServiceMixin';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import CommonTextDialog from '../../common/components/dialogs/CommonTextDialog.vue';
  import SelectProjectDialog from './SelectProjectDialog.vue';
  import SetUsageDepartmentDialog from './SetUsageDepartmentDialog.vue';
  import SelectPartnerDialog from '../../project/projectOverview/components/SelectPartnerDialog.vue';
  import BASE_API from '@/api/dataBase';
  import CONTRACTAPI from '@/api/intermodality/contract';

  export default {
    name: 'ContractOverview',
    mixins: [ContractOverviewMixin, IntermodalityCommonMixin, ContractServiceMixin],
    components: {
      SiruiSearch,
      CommonTextDialog,
      SelectProjectDialog,
      SelectPartnerDialog,
      SetUsageDepartmentDialog,
    },
    mounted() {
      this.getCompanyList();
      let name = this.$route.name;
      this.isCustomerContract = name == 'customerContract';
      this.$refs.siruiTable.setPageSize(10);
      // this.queryData = this.getDefaultSearchData();
      // this.getTableData();
      this.getButtonList();
    },
    data() {
      return {
        loading: false,
        isCustomerContract: true,
        tableColumns: [],
        menuButtonList: [], // 表格功能按钮
        selectedItems: [],
        companyList: [],
        departmentList: [],
        defaultDepartmentCode: [],
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this, this.isCustomerContract);
      },
      getExtraData() {
        let params = { projectStatus: ['xmzt03', 'xmzt05'] };
        if (this.isCustomerContract) {
          params.isConversionContract = '0';
        }
        return params;
      },
    },
    methods: {
      async getCompanyList() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          // personCompanyCode: this.userInfo.companyCode,
        };
        const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        // console.log(res.data.data.personDepartmentInfo,'personDepartmentInfo');
        this.companyList = res.data.data?.personCompanyInfo.filter((item) => {
          return item.personCompanyCode != 'OAC19';
        });
        console.log(res.data.data.personCompanyInfo, this.companyList);
        if (this.userInfo.companyCode != 'OAC19') {
          this.queryData = {
            ...this.queryData,
            platformCompanyName: this.userInfo.companyName,
            platformCompanyCode: this.userInfo.companyCode,
          };
        }
        if (this.queryData.platformCompanyCode) {
          this.department(this.queryData.platformCompanyCode);
        }
        this.getTableData();
      },
      getPartnerType(partner, query) {
        let partnerCode;
        if (this.isCustomerContract) {
          partnerCode = partner
            .map((v) => (query.isUpOrDown == '0' ? v.upPartnerCode : v.downPartnerCode))
            .join(',');
        } else {
          partnerCode = query.isUpOrDown == '0' ? partner.upPartnerCode : partner.downPartnerCode;
        }
        // this.convertContract(query.isUpOrDown, query.projectCode, partnerCode);
        // //项目转合同
        let params = {
          projectCode: query.projectCode,
          pageMode: 0,
          origin: 'createFrom',
          partnerCode: partnerCode,
        };
        this.toDetailPage(params);
        // this._convert(
        //   val,
        //   this.selectedItems[0].projectCode
        //   // this.selectedItems[0].isConversionContract
        // );
      },
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        // this.$refs.searchRef.$refs.saleDepartmentName[0].resetClick();
        // this.$refs.searchRef.$refs.createDepartmentName[0].resetClick();
        this.selectedItems = [];
        // this.queryData = this.getDefaultSearchData();
        this.getTableData();
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
        console.log(row);
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      selectProjectHandler(row) {
        let isUpOrDown = this.isCustomerContract ? '0' : '1';
        this.$refs.selectPartnerDialogRef.openModal(row.projectCode, isUpOrDown);
      },

      // 表格上面的按钮
      async chooseClick(type) {
        console.log(this.selectedItems);
        let empty = !this.selectedItems || !this.selectedItems.length;
        let justOne = this.selectedItems.length == 1;
        let contractStatus = justOne ? this.selectedItems[0].contractStatus : '';
        let contractCode = justOne ? this.selectedItems[0].contractCode : '';
        let contractType = justOne ? this.selectedItems[0].contractType : '';
        let statusName = this.getStatusName('contract', contractStatus);

        console.log('listStatus', empty, justOne, statusName);
        console.log('click', type);

        if (
          [
            'activate',
            'deactivate',
            'supplement',
            'copy',
            'renewval',
            'editContractNo',
            'setDepartment',
          ].includes(type)
        ) {
          if (empty || !justOne) {
            this.$message({
              type: 'error',
              message: '请选择一条数据',
            });
            return;
          }
        }

        if (type == 'create') {
          this.toDetailPage({ pageMode: 0, origin: 'create' });
        } else if (type == 'createFrom') {
          this.$refs.projectSearchRef.openModal();
        } else if (['renewval', 'copy'].includes(type)) {
          if (contractType == '1') {
            let name = type == 'copy' ? '复制' : '续签';
            this.$message({
              type: 'error',
              message: `结算条款不能${name}`,
            });
            return;
          }
          this.toDetailPage({ pageMode: 0, origin: 'copy', contractCode, btnType: type });
        } else if (type == 'activate') {
          if (statusName != '已停用') {
            this.$message({
              type: 'error',
              message: '请选择一条已停用的数据',
            });
            return;
          }
          let title = '';
          if (contractType != '0') {
            title = '结算条款';
          } else {
            if (this.isCustomerContract) {
              title = '客户合同';
            } else {
              title = '供方合同';
            }
          }
          this.$confirmAction(`${title}启用确认`, `是否确定要启用此${title}?`, '确认启用', '取消')
            .then(async () => {
              await this.handleUpdateStatus(true, contractCode, contractType, false);
            })
            .catch(() => {
              this.loading = false;
              this.$message({
                type: 'info',
                message: '已取消',
              });
            });
        } else if (type == 'deactivate') {
          if (statusName != '已生效') {
            this.$message({
              type: 'error',
              message: '请选择一条已生效的数据',
            });
            return;
          }
          if ((await this.checkSupplementUnderApproval(contractCode)) == false) {
            this.$message({
              type: 'error',
              message: '该合同的结算条款状态为审批中，无法停用，请检查！',
            });
            return;
          }
          let title = '';
          let message =
            '合同停用后，对应的结算条款将同步停用，且无法再创建订单。是否确定要停用此合同？';
          if (contractType != '0') {
            title = '结算条款';
            message = '是否确定要停用此结算条款?';
          } else {
            if (this.isCustomerContract) {
              title = '客户合同';
            } else {
              title = '供方合同';
            }
          }
          this.$confirmAction(`${title}停用确认`, message, '确认停用', '取消')
            .then(async () => {
              await this.handleUpdateStatus(false, contractCode, contractType, false);
            })
            .catch((e) => {
              console.log(e);
              this.loading = false;
              this.$message({
                type: 'info',
                message: '已取消',
              });
            });
        } else if (type == 'supplement') {
          if (statusName != '已生效') {
            this.$message({
              type: 'error',
              message: '请选择一条已生效的数据',
            });
            return;
          }
          if (contractType != '0') {
            this.$message({
              type: 'error',
              message:
                '新增失败！您选择的合同已为结算条款，不可再新增结算条款，请选择结算条款所属的常规合同进行结算条款维护',
            });
            return;
          }
          this.toDetailPage({ pageMode: 0, origin: 'supplement', contractCode });
        } else if (type == 'export') {
          this.exportHandler();
        } else if (type == 'editContractNo') {
          if (['审批中', '已失效', '修订审批中', '已停用'].includes(statusName)) {
            this.$message({
              type: 'error',
              message: '该合同状态下无法进行修改',
            });
            return;
          }
          this.toDetailPage({ pageMode: 1, origin: 'detail', contractCode, btnType: type });
        } else if (type == 'withdrawApprovalHandler') {
          if (empty) {
            this.$message({
              type: 'error',
              message: '请选择数据',
            });
            return;
          }
          if (this.selectedItems.some((item) => item.contractStatus != 'ZT02')) {
            this.$message.error('只有审批中才可以撤回审批');
            return;
          }
          this.withdrawApprovalHandler();
        } else if (type == 'setDepartment') {
          if (['审批中', '已失效', '修订审批中', '已停用'].includes(statusName)) {
            this.$message({
              type: 'error',
              message: '该合同状态下无法进行修改',
            });
            return;
          }
          this.setUsageDepartmentHandle();
        }
      },
      // 设置可用部门
      setUsageDepartmentHandle() {
        const defaultDepartment = this.selectedItems[0].usableDepartmentCode
          ? this.selectedItems[0].usableDepartmentCode.split(',')
          : [];
        defaultDepartment.unshift(this.selectedItems[0].businessDepartmentCode);
        this.defaultDepartmentCode = Array.from(new Set(defaultDepartment));
        this.$refs.setUsageDepartmentRef.dialogVisible = true;
      },
      async changeUsageDepartment(codeStr, nameStr) {
        const { data } = await this.$axios.post(CONTRACTAPI.SAVE_USAGE_DEPARTMENT, {
          usableDepartmentCode: codeStr,
          usableDepartmentName: nameStr,
          id: this.selectedItems[0].id,
        });
        if (data.code === 0) {
          this.$message.success('修改成功');
          this.$refs.setUsageDepartmentRef.dialogVisible = false;
          this.searchTrigger();
        }
      },
      // 撤回审批
      withdrawApprovalHandler() {
        const ids = this.selectedItems.map((item) => item.id);
        this.loading = true;
        this.$axios
          .post('/sales/mto/contract/withdrawOA', ids)
          .then((res) => {
            console.log(res);
            this.loading = false;
            const { code, msg } = res.data;
            if (code == 0) {
              this.resetBtnClick();
              this.$message.success('撤回成功');
            } else {
              this.$message.error(msg);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 导出 触发事件
      async exportHandler() {
        if (!this.selectedItems.length) {
          return this.$message.error('请先选择常规合同再进行导出');
        }
        let isSupplement = false;
        let contractCodeList = [];
        this.selectedItems.forEach((item) => {
          if (item.contractType == '1') {
            isSupplement = true;
          }
          contractCodeList.push(item.contractCode);
        });
        if (isSupplement) {
          return this.$message.error('选择数据包含结算条款，无法导出');
        }
        this.isLoading = true;
        let data = await this.$axios.post(CONTRACTAPI.EXPORT_CONTRACT, { contractCodeList });
        this.isLoading = false;
        if (data.data.code === 0) {
          window.location.href = data.data.data;
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败');
        }
      },
      dblclickEvent({ row }) {
        console.log('detail', row);
        let params = { contractCode: row.contractCode, pageMode: 1, origin: 'detail' };
        this.toDetailPage(params);
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns(this.isCustomerContract)).then(() => {
          this.tableColumns = defaultTableColumns(this.isCustomerContract);
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
